(() => {
  const root = document.querySelector('product-info[data-sgw-size-title]');
  const table = root?.querySelector('.product__description table#size-guide');
  if (!root || !table || table.closest('.sgw-size-scroll') || !table.tHead || !table.tBodies.length || table.tHead.rows[0].cells.length < 2) return;
  const rows = Array.from(table.tBodies).flatMap((body) => Array.from(body.rows));
  if (!rows.length || !rows.every((row) => row.cells.length >= 2)) return;
  const labels = rows.map((row) => row.cells[0].textContent.trim()).join(' ');
  if (!/(width|length|sleeve|chest|waist|hip|inseam|tolerance|height|diameter)/i.test(labels)) return;
  const isMugDimensions = root.dataset.sgwProductType === 'Mug' && /(height|diameter)/i.test(labels);
  const authoredGuide = table.closest('.sgw-measurement-guide[data-sgw-size-chart]');
  const section = document.createElement('section');
  section.className = 'sgw-size-guide';
  section.id = 'size-guide';
  const heading = document.createElement('h2');
  heading.id = 'sgw-size-title';
  heading.textContent = isMugDimensions ? root.dataset.sgwDimensionsTitle : root.dataset.sgwSizeTitle;
  const sourceHelp = authoredGuide?.querySelector(':scope > p');
  const help = sourceHelp || document.createElement('p');
  if (!sourceHelp) help.textContent = isMugDimensions ? root.dataset.sgwDimensionsHelp : /(?:\bcm\b|centimet)/i.test(labels) ? root.dataset.sgwSizeCentimeters : /(?:\bin\b|inch)/i.test(labels) ? root.dataset.sgwSizeInches : root.dataset.sgwSizeScroll;
  const scroller = document.createElement('div');
  scroller.className = 'sgw-size-scroll';
  scroller.setAttribute('role', 'region');
  scroller.setAttribute('aria-labelledby', heading.id);
  scroller.tabIndex = 0;
  table.parentNode.insertBefore(section, table);
  table.removeAttribute('id');
  table.classList.add('sgw-size-table');
  if (!table.caption) {
    const caption = table.createCaption();
    caption.className = 'visually-hidden';
    caption.textContent = root.dataset.sgwProductTitle;
  }
  const first = table.tHead.rows[0].cells[0];
  if (!first.textContent.trim()) first.textContent = root.dataset.sgwSizeMeasurement;
  first.setAttribute('scope', 'col');
  const columns = Array.from(table.tHead.rows[0].cells).slice(1);
  const sizeFieldset = Array.from(root.querySelectorAll('variant-selects fieldset')).find((fieldset) => fieldset.querySelector('legend')?.textContent.trim().toLowerCase() === 'size');
  const sizes = sizeFieldset ? Array.from(sizeFieldset.querySelectorAll('input[type="radio"]')).map((input) => input.value.trim()) : [];
  if (sizes.length === columns.length && columns.every((cell, index) => !cell.textContent.trim() || cell.textContent.trim().toLowerCase() === sizes[index].toLowerCase())) {
    columns.forEach((cell, index) => {
      if (!cell.textContent.trim()) cell.textContent = sizes[index];
      cell.setAttribute('scope', 'col');
    });
  }
  for (const row of rows) {
    const cell = row.cells[0];
    if (cell.tagName === 'TH') {
      cell.setAttribute('scope', 'row');
    } else {
      const header = document.createElement('th');
      header.setAttribute('scope', 'row');
      while (cell.firstChild) header.appendChild(cell.firstChild);
      cell.replaceWith(header);
    }
  }
  section.append(heading, help, scroller);
  scroller.appendChild(table);
  if (authoredGuide) {
    const duplicateHeading = authoredGuide.querySelector(':scope > h3');
    if (duplicateHeading?.textContent.trim() === 'Size guide') duplicateHeading.remove();
  }
})();


